import {
  NOTIFICATION_STATUS_LABELS,
  NotificationLogItem,
  NotificationLogStatus,
  NotificationRecipientStatus,
  RECIPIENT_STATUS_LABELS,
  TRIGGER_RULE_LABELS,
} from "../../models/notification-logs";
import { StatusTone } from "../../components/ui/StatusBadge";

export type PeriodPreset = "last7" | "last30" | "custom";

export const PERIOD_PRESETS: { key: PeriodPreset; label: string }[] = [
  { key: "last7", label: "Últimos 7 días" },
  { key: "last30", label: "Últimos 30 días" },
  { key: "custom", label: "Personalizado" },
];

export const startOfDay = (date: Date): Date => {
  const copy = new Date(date);
  copy.setHours(0, 0, 0, 0);
  return copy;
};

export const endOfDay = (date: Date): Date => {
  const copy = new Date(date);
  copy.setHours(23, 59, 59, 999);
  return copy;
};

export const rangeForPreset = (
  preset: PeriodPreset,
  today: Date
): { dateFrom: Date; dateTo: Date } | null => {
  if (preset === "custom") {
    return null;
  }
  const days = preset === "last7" ? 7 : 30;
  const dateFrom = startOfDay(new Date(today));
  dateFrom.setDate(dateFrom.getDate() - (days - 1));
  return { dateFrom, dateTo: endOfDay(today) };
};

export const notificationTypeLabel = (item: NotificationLogItem): string =>
  item.type === "MANUAL" ? "Manual" : "Automática";

export const notificationSenderLabel = (item: NotificationLogItem): string => {
  if (item.type === "AUTOMATIC") {
    const rule = item.triggerRule ? TRIGGER_RULE_LABELS[item.triggerRule] : null;
    return rule ? `Sistema · ${rule}` : "Sistema";
  }
  return item.sentBy ?? "—";
};

export const notificationStatusTone = (status: NotificationLogStatus): StatusTone => {
  switch (status) {
    case "SENT":
      return "success";
    case "PARTIAL":
      return "warning";
    case "FAILED":
      return "error";
    default:
      return "info";
  }
};

export const notificationStatusLabel = (status: NotificationLogStatus): string =>
  NOTIFICATION_STATUS_LABELS[status];

export const recipientStatusTone = (status: NotificationRecipientStatus): StatusTone => {
  switch (status) {
    case "SENT":
      return "success";
    case "NO_TOKEN":
      return "pending";
    default:
      return "error";
  }
};

export const recipientStatusLabel = (status: NotificationRecipientStatus): string =>
  RECIPIENT_STATUS_LABELS[status];

export const truncate = (value: string, max = 90): string =>
  value.length > max ? `${value.slice(0, max)}…` : value;
